// Loader.jsx
import React, { useState, useEffect } from 'react';
import { loaderState } from '../../../helpers/loaderService';
// import { loaderState } from './loaderService';

const Loader = () => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Subscribe to loader state changes
    const subscription = loaderState.subscribe(state => {
      setIsLoading(state);
    });

    // Clean up subscription
    return () => subscription.unsubscribe();
  }, []);

  if (!isLoading) return null;

  return (
    <div className="loader-overlay">
      <div className="loader-spinner">
        <div className="spinner"></div>
      </div>
    </div>
  );
};

export default Loader;